import styled from "styled-components";

export const ButtonContainer = styled.div`
  width: 40%;
  height: 80px;
  display: flex;
  justify-content: space-around;
  margin: auto;
`;
